import { IState } from '../../../store';

export const selectOfferId = (state: IState) => {
  return state.offerData.offer.id;
};
